import { Injectable } from '@angular/core';
import { LoadingController, ToastController, NavController, AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class UtilserviceService {

  private activeRequests = 0;
  private loader: HTMLIonLoadingElement | null = null;
  private isLoaderPresenting = false;

  constructor(
    private loadingController: LoadingController,
    private toastController: ToastController,
    public nav: NavController,
    private alertController: AlertController
  ) { }

  /* -------------------- TOAST -------------------- */

  async presentToast(msg: string, duration: number = 2000) {
    const toast = await this.toastController.create({
      message: msg,
      duration: duration,
      mode: 'ios',
      position: 'bottom'
    });

    await toast.present();
  }

  /* -------------------- SUCCESS TOAST -------------------- */
  async successToast(message: string, duration: number = 2000) {
    const toast = await this.toastController.create({
      message: `<ion-icon name="checkmark-circle-outline"></ion-icon> ${message}`,
      duration: duration,
      cssClass: 'toast-success',
      mode: 'ios',
      position: 'bottom'
    });

    await toast.present();
  }

  /* -------------------- WARNING TOAST -------------------- */
  async warningToast(message: string, duration: number = 2000) {
    const toast = await this.toastController.create({
      message: `<ion-icon name="alert-circle-outline"></ion-icon> ${message}`,
      duration: duration,
      cssClass: 'toast-warning',
      mode: 'ios',
      position: 'bottom'
    });

    await toast.present();
  }

  /* -------------------- ERROR TOAST -------------------- */
  async errorToast(message: string, duration: number = 2000) {
    const toast = await this.toastController.create({
      message: `<ion-icon name="close-circle-outline"></ion-icon> ${message}`,
      duration: duration,
      cssClass: 'toast-error',
      mode: 'ios',
      position: 'bottom'
    });

    await toast.present();
  }

  /* -------------------- INFO TOAST -------------------- */
  async infoToast(message: string, duration: number = 2000) {
    const toast = await this.toastController.create({
      message: `<ion-icon name="information-circle-outline"></ion-icon> ${message}`,
      duration: duration,
      cssClass: 'toast-info',
      mode: 'ios',
      position: 'bottom'
    });

    await toast.present();
  }

  /* -------------------- ALERT POPUP -------------------- */
  async showAlert(header: string, message: string, buttonText: string = 'OK') {
    const alert = await this.alertController.create({
      header: header,
      message: message,
      mode: 'ios',
      buttons: [buttonText]
    });

    await alert.present();
  }

  /* -------------------- LOADER START -------------------- */

  async startLoad() {
    this.activeRequests++;

    // Already presenting
    if (this.isLoaderPresenting) {
      return;
    }

    if (this.activeRequests === 1) {
      this.isLoaderPresenting = true;

      this.loader = await this.loadingController.create({
        cssClass: 'custom-loader',
        spinner: 'crescent',
        backdropDismiss: false
      });

      await this.loader.present();
    }
  }

  /* -------------------- LOADER DISMISS -------------------- */

  async dismissLoader() {

    if (this.activeRequests > 0) {
      this.activeRequests--;
    }

    if (this.activeRequests === 0 && this.loader) {
      try {
        await this.loader.dismiss();
      } catch (error) {
        // Ignore double dismiss errors
      }

      this.loader = null;
      this.isLoaderPresenting = false;
    }
  }

  /* -------------------- FORCE RESET (Emergency Use) -------------------- */

  async resetLoader() {
    this.activeRequests = 0;

    if (this.loader) {
      try {
        await this.loader.dismiss();
      } catch { }
    }

    this.loader = null;
    this.isLoaderPresenting = false;
  }
}